import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import ReactPlayer from "react-player";
import { IMessage } from "./IChannel";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import socket, { IResponse } from "../../socket";
import { useTranslation } from "react-i18next";
import { useState } from "react";

interface IProps {
    message: IMessage;
    deleteMessage?: (id: number) => void;
}

export default function Message({ message, deleteMessage }: IProps) {
    const { t } = useTranslation();
    const [openDialog, setOpenDialog] = useState(false);



    const handleDelete = () => {
        socket.emit('channel:delete_message', message.id, (data: IResponse<null>) => {
            if (data.success && deleteMessage) {
                deleteMessage(message.id);
            }
        });
    }

    const handleOpenDialog = () => {
        setOpenDialog(true);
    }


    const handleCloseDialog = () => {
        setOpenDialog(false);
    }

    return (
        <div className="pb-3">
            <Box sx={{ bgcolor: 'background.default' }} className='w-4/5 rounded p-1'>
                {
                    message.type === 'image' ? <img src={message.image} alt='' className='w-full rounded-sm' /> : ''
                }
                {
                    message.type === 'video' ?
                        <ReactPlayer className='w-full h-fit rounded-sm overflow-hidden' controls url={message.video} />
                        : ''
                }
                <div className="p-3">
                    <Typography component='pre' className='font-medium text-sm whitespace-pre-line'>{message.text}</Typography>
                    <div className="flex flex-row justify-between items-center">
                        <Typography className='text-xs' sx={{ color: 'grey.600' }}>{message.createdAt.toLocaleDateString('fa', { year: "numeric", month: "long", day: "numeric", })}</Typography>
                        <div className="flex flex-row space-x-1 space-x-reverse items-center">
                            <Typography className='text-xs' sx={{ color: 'grey.600' }}>{message.createdAt.toLocaleTimeString('fa', { hour: "2-digit", minute: "2-digit" })}</Typography>
                            <IconButton onClick={handleOpenDialog} color='error'><DeleteIcon /></IconButton>
                        </div>
                    </div>
                </div>
            </Box>

            <Dialog open={openDialog} onClose={handleCloseDialog}>
                <DialogTitle>{t('delete_message')}</DialogTitle>
                <DialogContent>
                    <Typography>{t('delete_message_description')}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog}>{t('close')}</Button>
                    <Button variant="contained" onClick={handleDelete}>{t('remove')}</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
